module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/bg-db2f95e4270e8ab089ad16a9a6f97358.svg";